import { useLocation, useNavigate } from 'react-router';
import { ApiKeyEntry } from 'components/ApiKeyEntry';
import { hasNyrisApiKey } from 'components/ApiKeyInput';
import {
  consumeNeedsResearchAfterApiKey,
  sanitizeReturnTo,
} from 'components/apiKeyNavigation';
import { useImageSearch } from 'hooks/useImageSearch';
import useRequestStore from 'stores/request/requestStore';

interface ApiKeyLocationState {
  returnTo?: string;
}

function ApiKeyPage(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const { singleImageSearch } = useImageSearch();
  const query = useRequestStore(state => state.query);
  const requestImages = useRequestStore(state => state.requestImages);
  const regions = useRequestStore(state => state.regions);

  const returnTo = sanitizeReturnTo(
    (location.state as ApiKeyLocationState | null)?.returnTo,
  );

  const handleDone = () => {
    if (!hasNyrisApiKey()) {
      return;
    }

    const shouldResearch = consumeNeedsResearchAfterApiKey();
    const image = requestImages[0];
    const text = query?.trim();

    if (shouldResearch && (image || text)) {
      singleImageSearch({
        image,
        imageRegion: regions[0],
        text: image ? undefined : text,
        settings: window.settings,
        showFeedback: Boolean(image),
        newSearch: true,
      });
      navigate('/result');
      return;
    }

    navigate(returnTo === '/api-key' ? '/' : returnTo);
  };

  return (
    <div className="flex flex-1 items-center justify-center h-full bg-[#FAFAFA]">
      <ApiKeyEntry autoFocus onDone={handleDone} />
    </div>
  );
}

export default ApiKeyPage;
